
import { ProductCard, ProductCardProps } from "./ProductCard";
import { getOptimizedImageUrl } from "@/types/product";

interface ProductGridProps {
  products: ProductCardProps[];
}

export function ProductGrid({ products }: ProductGridProps) {
  // Apply image optimization to product images
  const optimizedProducts = products.map(product => ({
    ...product,
    image: getOptimizedImageUrl(product.image)
  }));

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
      {optimizedProducts.map((product) => (
        <ProductCard
          key={product.id}
          {...product}
        />
      ))}
    </div>
  );
}
